import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { supabase } from './supabase';

const isDevelopment = process.env.NODE_ENV === 'development';
const websiteDomain = process.env.REACT_APP_WEBSITE_DOMAIN || 'https://shipcompareafrica.com/';

export const api = axios.create({
  baseURL: process.env.REACT_APP_FUNCTION_API_BASE_URL || 'http://localhost:54321/functions/v1/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
); 